import changeCart from '../../lib/changeCart';
import changeLineItemOption from '../../lib/changeLineItemOption';
import { CLASSES } from '../../utils/constants';

const initCartPage = () => {
  const cartLineItemSelector = '[data-cart-line-item]';
  const cartSubscribeToggleSelector = '[data-cart-subscribe-toggle]';
  const cartSubscribeSelectSelector = '[data-cart-subscribe-select]';
  const cartRemoveItemSelector = '[data-cart-remove-item]';
  const quantityInputs = document.querySelectorAll('[data-cart-qty]');

  quantityInputs.forEach((input) => {
    input.addEventListener('change', async () => {
      const lineItemKey = input.dataset.cartQty;
      const newQty = +input.value;
      const line = input.closest('[data-cart-line-item]');
      if (line) {
        line.classList.add(CLASSES.OPACITY_50);
      }
      input.disabled = true;
      await changeCart(lineItemKey, newQty);
      window.location.reload();
    });

  });

  document.addEventListener('change', async (evt) => {
    const subscribeSelect = evt.target.closest(cartSubscribeSelectSelector);
    if (!subscribeSelect) return;

    const lineItem = subscribeSelect.closest(cartLineItemSelector);
    const lineNumber = +subscribeSelect.dataset.subscribeLine;
    const quantity = +subscribeSelect.dataset.subscribeQuantity || 1;
    const sellingPlanId = subscribeSelect.value ? +subscribeSelect.value : null;

    if (!lineNumber) return;

    subscribeSelect.disabled = true;
    if (lineItem) {
      lineItem.classList.add(CLASSES.OPACITY_50);
    }

    try {
      await changeLineItemOption({
        lineNumber,
        quantity,
        sellingPlanId
      });
      window.location.reload();
    } catch (error) {
      console.error('Failed to update subscription option:', error);
      subscribeSelect.disabled = false;
      if (lineItem) {
        lineItem.classList.remove(CLASSES.OPACITY_50);
      }
    }
  });

  document.addEventListener('click', async (evt) => {
    const subscribeToggleBtn = evt.target.closest(cartSubscribeToggleSelector);
    if (subscribeToggleBtn) {
      evt.preventDefault();
      const lineItem = subscribeToggleBtn.closest(cartLineItemSelector);
      const subscribeSelect = lineItem?.querySelector(cartSubscribeSelectSelector);
      const isOpen = subscribeToggleBtn.classList.toggle('open');

      subscribeToggleBtn.setAttribute('aria-pressed', String(isOpen));
      if (subscribeSelect) {
        subscribeSelect.hidden = !isOpen;
      }

      if (!isOpen && subscribeSelect) {
        const hasOneTimeOption = Boolean(subscribeSelect.querySelector('option[value=""]'));
        if (!hasOneTimeOption) {
          subscribeToggleBtn.classList.add('open');
          subscribeToggleBtn.setAttribute('aria-pressed', 'true');
          subscribeSelect.hidden = false;
          return;
        }

        const hasActiveSubscription = subscribeSelect.value !== '';
        if (!hasActiveSubscription) return;

        const lineNumber = +subscribeSelect.dataset.subscribeLine;
        const quantity = +subscribeSelect.dataset.subscribeQuantity || 1;

        if (!lineNumber) return;

        subscribeSelect.disabled = true;
        subscribeToggleBtn.classList.add(CLASSES.POINTER_EVENTS_NONE);
        if (lineItem) {
          lineItem.classList.add(CLASSES.OPACITY_50);
        }

        try {
          await changeLineItemOption({
            lineNumber,
            quantity,
            sellingPlanId: null
          });
          window.location.reload();
        } catch (error) {
          console.error('Failed to switch to one-time purchase:', error);
          subscribeSelect.disabled = false;
          subscribeToggleBtn.classList.remove(CLASSES.POINTER_EVENTS_NONE);
          if (lineItem) {
            lineItem.classList.remove(CLASSES.OPACITY_50);
          }
        }
      }

      return;
    }

    const removeBtn = evt.target.closest(cartRemoveItemSelector);
    if (!removeBtn) return;

    evt.preventDefault();
    removeBtn.classList.add(CLASSES.POINTER_EVENTS_NONE);
    const lineItem = removeBtn.closest(cartLineItemSelector);
    const lineItemKey = removeBtn.dataset.cartRemoveItem;
    if (lineItem) {
      lineItem.classList.add(CLASSES.OPACITY_50);
    }

    await changeCart(lineItemKey, 0);
    window.location.reload();
  });
};

export default initCartPage;
